import { useContext, useState } from "react";
import { Button } from "../tailwind/button";
import { CustomerContext } from "../../providers";
import { Heading } from "../tailwind/heading";
import { api } from "../../api";
import { CheckOnBoardingPrerequisites } from "./CheckOnBoardingPrerequisites";

export const ChoosePlan = () => {
  const { customer } = useContext(CustomerContext);
  const [isLoading, setIsLoading] = useState(false);
  const [prerequisites, setPrerequisites] = useState({});

  return (
    <div className="flex flex-col justify-center items-center h-[70vh]">
      {!customer.isSubscribed && (
        <>
          <CheckOnBoardingPrerequisites
            prerequisites={prerequisites}
            setPrerequisites={setPrerequisites}
            customer={customer}
          ></CheckOnBoardingPrerequisites>

          <Button
            loading={isLoading}
            disabled={
              prerequisites?.optinsPlanIsMissing ||
              prerequisites?.subscriptionPlanIsMissing
            }
            onClick={async () => {
              setIsLoading(true);
              const checkoutUrl = await api.createStripeCheckoutSession({
                customerId: customer.id,
              });
              window.open(checkoutUrl, "_self");
              setIsLoading(false);
            }}
          >
            Go to checkout
          </Button>
        </>
      )}
      {customer.isSubscribed && (
        <Heading>You are subscribed to Simio 🎉</Heading>
      )}
    </div>
  );
};
